"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.importAccountsReduce = exports.syncNewAccountsToImport = exports.importAccountsMakeItems = void 0;
var logs_1 = require("@ledgerhq/logs");
var cross_1 = require("../cross");
var index_1 = require("./index");
var joinSwapHistories_1 = __importDefault(require("../exchange/swap/joinSwapHistories"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var bridge_1 = require("../bridge");
var promise_1 = require("../promise");
var env_1 = require("../env");
var operators_1 = require("rxjs/operators");
var itemModeDisplaySort = {
    create: 1,
    update: 2,
    id: 3,
    unsupported: 4
};
var importAccountsMakeItems = function (_a) {
    var result = _a.result, accounts = _a.accounts, items = _a.items;
    return result.accounts
        .map(function (accInput) {
        var prevItem = (items || []).find(function (item) { return item.account.id === accInput.id; });
        if (prevItem)
            return prevItem;
        try {
            var account_1 = (0, cross_1.accountDataToAccount)(accInput);
            var error = (0, index_1.checkAccountSupported)(account_1);
            if (error) {
                return {
                    initialAccountId: account_1.id,
                    account: account_1,
                    mode: "unsupported"
                };
            }
            var migratableAccount = accounts.find(function (a) {
                return (0, index_1.findAccountMigration)(a, [account_1]);
            });
            if (migratableAccount) {
                // in migration case, we completely replace the older account
                return {
                    initialAccountId: migratableAccount.id,
                    account: account_1,
                    mode: "update"
                };
            }
            var existingAccount = accounts.find(function (a) { return a.id === accInput.id; });
            if (existingAccount) {
                // only the name is supposed to change. rest is never changing
                if (existingAccount.name === accInput.name &&
                    (0, isEqual_1["default"])(existingAccount.swapHistory, account_1.swapHistory)) {
                    return {
                        initialAccountId: existingAccount.id,
                        account: existingAccount,
                        mode: "id"
                    };
                }
                return {
                    initialAccountId: existingAccount.id,
                    account: __assign(__assign({}, existingAccount), { name: accInput.name, swapHistory: (0, joinSwapHistories_1["default"])(existingAccount.swapHistory, account_1.swapHistory) }),
                    mode: "update"
                };
            }
            return {
                initialAccountId: account_1.id,
                account: account_1,
                mode: "create"
            };
        }
        catch (e) {
            (0, logs_1.log)("error", String(e));
            return null;
        }
    })
        .filter(Boolean)
        .sort(function (a, b) {
        return itemModeDisplaySort[a.mode] -
            itemModeDisplaySort[b.mode];
    });
};
exports.importAccountsMakeItems = importAccountsMakeItems;
/**
 *
 * @param items: result of importAccountsMakeItems
 * @param selectedAccounts: user's selected accounts
 * @param bridgeCache: the bridge cache created on user land to prepare currency for a sync
 * @param blacklistedTokenIds: the list of blacklisted token ids to ignore sync with
 * @returns SyncNewAccountsOutput
 */
var syncNewAccountsToImport = function (_a, bridgeCache, blacklistedTokenIds) {
    var items = _a.items, selectedAccounts = _a.selectedAccounts;
    return __awaiter(void 0, void 0, void 0, function () {
        var selectedItems, synchronized, failed;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectedItems = items.filter(function (item) {
                        return selectedAccounts.includes(item.account.id);
                    });
                    synchronized = {};
                    failed = {};
                    return [4 /*yield*/, (0, promise_1.promiseAllBatched)((0, env_1.getEnv)("SYNC_MAX_CONCURRENT"), selectedItems, function (_a) {
                            var account = _a.account;
                            return __awaiter(void 0, void 0, void 0, function () {
                                var bridge, syncConfig, observable, reduced, synced, e_1;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 3, , 4]);
                                            bridge = (0, bridge_1.getAccountBridge)(account);
                                            return [4 /*yield*/, bridgeCache.prepareCurrency(account.currency)];
                                        case 1:
                                            _b.sent();
                                            syncConfig = {
                                                paginationConfig: {},
                                                blacklistedTokenIds: blacklistedTokenIds
                                            };
                                            observable = bridge.sync(account, syncConfig);
                                            reduced = observable.pipe((0, operators_1.reduce)(function (a, f) { return f(a); }, account));
                                            return [4 /*yield*/, reduced.toPromise()];
                                        case 2:
                                            synced = _b.sent();
                                            synchronized[account.id] = synced;
                                            return [3 /*break*/, 4];
                                        case 3:
                                            e_1 = _b.sent();
                                            failed[account.id] = e_1;
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            });
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, { synchronized: synchronized, failed: failed }];
            }
        });
    });
};
exports.syncNewAccountsToImport = syncNewAccountsToImport;
/**
 *
 * @param existingAccounts
 * @param items: value resulting of importAccountsMakeItems
 * @params selectedAccounts: array of all account ids selected by user for import
 * @param syncedNewAccounts: accounts resulting of syncNewAccountsToImport(). all accounts that would be missing from that list would be ignored to be imported (fresh sync is needed to make sure the accounts are "ready")
 * @returns all accounts
 */
var importAccountsReduce = function (existingAccounts, _a) {
    var e_2, _b;
    var items = _a.items, selectedAccounts = _a.selectedAccounts, syncResult = _a.syncResult;
    var accounts = existingAccounts.slice(0);
    var selectedItems = items.filter(function (item) {
        return selectedAccounts.includes(item.account.id);
    });
    var _loop_1 = function (mode, id, initialAccountId) {
        var account = syncResult.synchronized[id];
        if (!account)
            return "continue";
        switch (mode) {
            case "create": {
                var exists = accounts.find(function (a) { return a.id === initialAccountId || a.id === id; });
                if (!exists) {
                    // prevent duplicate cases to happen (in case of race condition)
                    accounts.push(account);
                }
                break;
            }
            case "update": {
                var item = accounts.find(function (a) { return a.id === initialAccountId || a.id === id; });
                var i = accounts.indexOf(item);
                if (i !== -1) {
                    accounts[i] = account;
                }
                break;
            }
            default:
        }
    };
    try {
        for (var selectedItems_1 = __values(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
            var _c = selectedItems_1_1.value, mode = _c.mode, id = _c.account.id, initialAccountId = _c.initialAccountId;
            _loop_1(mode, id, initialAccountId);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (selectedItems_1_1 && !selectedItems_1_1.done && (_b = selectedItems_1["return"])) _b.call(selectedItems_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return accounts;
};
exports.importAccountsReduce = importAccountsReduce;
//# sourceMappingURL=importAccounts.js.map